import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import answerSearchResource from 'src/actions/answers/answerSearchResource';
import searchDropdownResource, { AnswerSearchQueryFilter } from 'src/actions/searchDropdown/searchDropdownResource';

const usePublicAnswersFilter = ({
  fieldName,
  language,
  audienceId,
}: {
  fieldName?: string;
  language: string;
  audienceId: string;
}) => {
  const { request: searchForAnswer } = fieldName ? searchDropdownResource.effects : answerSearchResource.effects;
  const dispatch = useDispatch();

  return useCallback(
    (text: string) => {
      // get only public answers [selfService]
      const filter: AnswerSearchQueryFilter = {
        hasFields: [
          { language, name: 'CONTENTS' },
          { language, name: 'SELF_SERVICE' },
        ],
      };

      if (audienceId) {
        filter.audienceIds = [audienceId];
      }
      dispatch(searchForAnswer({ fieldName, filter, language, text }));
    },
    [audienceId, dispatch, fieldName, searchForAnswer, language]
  );
};

export default usePublicAnswersFilter;
